var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var _initialized;
import "./waapi-patch-BCt4pEht.js";
import "./cookie-banner-layout-DZP7Q0uT.js";
import "./section-anchor-scroll-Bvm-mXVl.js";
import { isMobileAnim } from "./mobile-anim-gate-Btn1wVuD.js";
const requestIdleCallback = typeof window.requestIdleCallback == "function" ? (cb, options) => window.requestIdleCallback(cb, { timeout: 2e3, ...options }) : setTimeout;
const _triggerEvents = ["pointerdown", "keydown", "scroll", "touchstart", "wheel"];
const _presenceEvents = ["pointermove"];
const _responsivePresenceQuery = typeof window !== "undefined" ? window.matchMedia("(max-width: 991.98px)") : null;
let _interacted = false;
let _interactQueue = [];
let _userPresent = false;
let _presenceQueue = [];
let _pointerPresent = false;
let _pointerPresenceQueue = [];
const isBot = typeof navigator !== "undefined" && /bot|googlebot|crawler|spider|robot|crawling|lighthouse/i.test(navigator.userAgent || "");
const isDesignMode = typeof window !== "undefined" && window.Shopify && window.Shopify.designMode;
const DESIGN_MODE_ASSET_HYDRATION_EVENT = "bear:design-mode-assets:hydrate";
function _markUserPresence() {
  if (isBot) return;
  requestAnimationFrame(() => {
    const body = document.body;
    if (body && !body.hasAttribute("data-user-presence")) {
      body.setAttribute("data-user-presence", "");
    }
  });
}
function _flushPresenceQueue() {
  if (_userPresent) return;
  _userPresent = true;
  _responsivePresenceQuery == null ? void 0 : _responsivePresenceQuery.removeEventListener("change", _onResponsivePresence);
  _markUserPresence();
  const queue = _presenceQueue.slice();
  _presenceQueue = [];
  for (const cb of queue) {
    try {
      cb();
    } catch (e) {
    }
  }
}
function _flushPointerPresenceQueue() {
  if (_pointerPresent) return;
  _pointerPresent = true;
  if (typeof window !== "undefined") {
    _presenceEvents.forEach((evt) => window.removeEventListener(evt, _onFirstPresence));
  }
  const queue = _pointerPresenceQueue.slice();
  _pointerPresenceQueue = [];
  for (const cb of queue) {
    try {
      cb();
    } catch (e) {
    }
  }
}
function _isMeaningfulPointerMove(event) {
  if (!event || isBot || event.isTrusted === false || event.isPrimary === false || event.pointerType && event.pointerType !== "mouse" || document.visibilityState !== "visible") return false;
  return event.movementX !== 0 || event.movementY !== 0;
}
function _onFirstPresence(event) {
  if (_pointerPresent || !_isMeaningfulPointerMove(event)) return;
  window.__firstPointerPresence = {
    clientX: event.clientX,
    clientY: event.clientY,
    movementX: event.movementX,
    movementY: event.movementY,
    pointerType: "mouse"
  };
  _flushPointerPresenceQueue();
  _flushPresenceQueue();
}
function _onResponsivePresence(event) {
  if (_userPresent || isBot) return;
  _flushPresenceQueue();
}
function _flushQueue() {
  if (_interacted) return;
  _interacted = true;
  _flushPresenceQueue();
  if (typeof window !== "undefined") {
    _triggerEvents.forEach((evt) => window.removeEventListener(evt, _onFirstInteract));
  }
  const queue = _interactQueue.slice();
  _interactQueue = [];
  for (const cb of queue) {
    try {
      cb();
    } catch (e) {
    }
  }
}
function _onFirstInteract(event) {
  if (_interacted) return;
  if (event && event.type) {
  } else {
  }
  _flushQueue();
}
if (typeof window !== "undefined") {
  if (isDesignMode) {
    setTimeout(_onFirstInteract, 0);
  } else {
    if (window.__earlyUserPresence && !isBot) {
      _flushPointerPresenceQueue();
      _flushPresenceQueue();
    }
    if (window.__earlyResponsivePresence && !isBot) {
      _flushPresenceQueue();
    }
    if (window.__earlyInteraction) {
      _flushQueue();
    } else {
      _triggerEvents.forEach(
        (evt) => window.addEventListener(evt, _onFirstInteract, { once: true, passive: true })
      );
    }
    if (!_pointerPresent) {
      _presenceEvents.forEach(
        (evt) => window.addEventListener(evt, _onFirstPresence, { passive: true })
      );
    }
    if (!_userPresent) {
      _responsivePresenceQuery.addEventListener("change", _onResponsivePresence);
    }
  }
}
function onFirstUserPresence(cb) {
  if (_userPresent) {
    cb();
    return;
  }
  const run = () => {
    const index = _presenceQueue.indexOf(run);
    if (index !== -1) _presenceQueue.splice(index, 1);
    cb();
  };
  _presenceQueue.push(run);
}
function onFirstPointerPresence(cb) {
  if (_pointerPresent) {
    cb();
    return;
  }
  const run = () => {
    const index = _pointerPresenceQueue.indexOf(run);
    if (index !== -1) _pointerPresenceQueue.splice(index, 1);
    cb();
  };
  _pointerPresenceQueue.push(run);
}
function onFirstUserPresenceIdle(cb) {
  onFirstUserPresence(() => requestIdleCallback(cb));
}
function hasUserPresence() {
  return _userPresent;
}
function onFirstInteraction(cb, safetyMs = 0) {
  if (_interacted) {
    cb();
    return;
  }
  let settled = false;
  let safetyTimer;
  const run = () => {
    if (settled) return;
    settled = true;
    if (safetyTimer) clearTimeout(safetyTimer);
    const index = _interactQueue.indexOf(run);
    if (index !== -1) _interactQueue.splice(index, 1);
    cb();
  };
  _interactQueue.push(run);
  if (safetyMs > 0 && !isBot) {
    safetyTimer = setTimeout(run, isDesignMode ? 0 : safetyMs);
  }
}
function onFirstInteractionIdle(cb) {
  onFirstInteraction(() => requestIdleCallback(cb));
}
function hasInteracted() {
  return _interacted;
}
function preserveLoadedStylesheets(currentRoot, replacementRoot) {
  const currentStylesheets = new Map(
    Array.from(currentRoot.querySelectorAll('link[rel~="stylesheet"][href]')).map((stylesheet) => [
      stylesheet.href,
      stylesheet
    ])
  );
  const retainedStylesheetHrefs = new Set(
    Array.from(document.querySelectorAll('link[rel~="stylesheet"][href]')).filter((stylesheet) => !currentRoot.contains(stylesheet)).map((stylesheet) => stylesheet.href)
  );
  replacementRoot.querySelectorAll('link[rel~="stylesheet"][href]').forEach((replacementStylesheet) => {
    const href = replacementStylesheet.href;
    if (retainedStylesheetHrefs.has(href)) {
      replacementStylesheet.remove();
      return;
    }
    const currentStylesheet = currentStylesheets.get(href);
    if (currentStylesheet) {
      replacementStylesheet.replaceWith(currentStylesheet);
      currentStylesheets.delete(href);
    }
    retainedStylesheetHrefs.add(href);
  });
}
const _installedSectionStylesheets = /* @__PURE__ */ new Map();
const _linkedResponseStylesheetLoads = /* @__PURE__ */ new WeakMap();
const LINKED_STYLESHEET_LOAD_TIMEOUT = 5e3;
function installSectionStylesheets(source) {
  var _a;
  if (!(source == null ? void 0 : source.querySelectorAll)) return;
  for (const stylesheet of source.querySelectorAll("style[data-section-stylesheet]")) {
    const css = (_a = stylesheet.textContent) == null ? void 0 : _a.trim();
    if (!css) continue;
    const installed = _installedSectionStylesheets.get(css);
    if (installed == null ? void 0 : installed.isConnected) {
      if (installed.parentNode !== document.head) document.head.appendChild(installed);
      if (stylesheet !== installed) stylesheet.remove();
      continue;
    }
    const existing = Array.from(
      document.querySelectorAll("style[data-section-stylesheet]")
    ).find((style) => {
      var _a2;
      return ((_a2 = style.textContent) == null ? void 0 : _a2.trim()) === css;
    });
    const activeStylesheet = existing || stylesheet;
    if (existing) {
      if (existing.parentNode !== document.head) document.head.appendChild(existing);
      if (stylesheet !== existing) stylesheet.remove();
    } else {
      document.head.appendChild(activeStylesheet);
    }
    _installedSectionStylesheets.set(css, activeStylesheet);
  }
}
function installLinkedResponseStylesheets(source) {
  if (!(source == null ? void 0 : source.querySelectorAll)) return Promise.resolve();
  const activeStylesheets = new Map(
    Array.from(
      document.querySelectorAll('link[rel~="stylesheet"][href]'),
      (link) => [link.href, link]
    )
  );
  const stylesheetLoads = [];
  for (const stylesheet of source.querySelectorAll('link[rel~="stylesheet"][href]')) {
    const activeStylesheet = activeStylesheets.get(stylesheet.href);
    if (activeStylesheet) {
      if (activeStylesheet.parentNode !== document.head) {
        document.head.appendChild(activeStylesheet);
      }
      stylesheet.remove();
      stylesheetLoads.push(waitForLinkedStylesheet(activeStylesheet));
      continue;
    }
    stylesheet.dataset.dynamicResponseStylesheet = "";
    const loadPromise = waitForLinkedStylesheet(stylesheet);
    document.head.appendChild(stylesheet);
    activeStylesheets.set(stylesheet.href, stylesheet);
    stylesheetLoads.push(loadPromise);
  }
  return Promise.all(stylesheetLoads).then(() => void 0);
}
function isLinkedStylesheetLoaded(stylesheet) {
  try {
    return Boolean(stylesheet.sheet);
  } catch {
    return true;
  }
}
function waitForLinkedStylesheet(stylesheet) {
  if (isLinkedStylesheetLoaded(stylesheet)) return Promise.resolve();
  const pendingLoad = _linkedResponseStylesheetLoads.get(stylesheet);
  if (pendingLoad) return pendingLoad;
  const loadPromise = new Promise((resolve) => {
    let timeoutId;
    const settle = () => {
      stylesheet.removeEventListener("load", settle);
      stylesheet.removeEventListener("error", settle);
      clearTimeout(timeoutId);
      resolve();
    };
    stylesheet.addEventListener("load", settle, { once: true });
    stylesheet.addEventListener("error", settle, { once: true });
    timeoutId = setTimeout(settle, LINKED_STYLESHEET_LOAD_TIMEOUT);
    queueMicrotask(() => {
      if (isLinkedStylesheetLoaded(stylesheet)) settle();
    });
  });
  _linkedResponseStylesheetLoads.set(stylesheet, loadPromise);
  return loadPromise;
}
const _activatedInteractionAssets = /* @__PURE__ */ new Set();
const _interactionModuleLoads = /* @__PURE__ */ new Map();
const INTERACTION_MODULE_LOAD_TIMEOUT = 8e3;
const INTERACTION_MODULE_MAX_ATTEMPTS = 2;
const INTERACTION_ELEMENT_DEFINITION_TIMEOUT = 2e3;
const INTERACTION_UNTRACKED_DEFINITION_TIMEOUT = INTERACTION_MODULE_LOAD_TIMEOUT + INTERACTION_ELEMENT_DEFINITION_TIMEOUT;
const INTERACTION_CONTROLLER_READY_TIMEOUT = 8e3;
function getInteractionAssetKey(type, url) {
  if (!url) return null;
  try {
    return `${type}:${new URL(url, document.baseURI).href}`;
  } catch {
    return `${type}:${url}`;
  }
}
function hasActiveStylesheet(stylesheetKey) {
  if (!stylesheetKey) return false;
  return Array.from(document.querySelectorAll('link[rel~="stylesheet"][href]')).some(
    (link) => getInteractionAssetKey("stylesheet", link.href) === stylesheetKey
  );
}
function matchesInteractionScope(asset, scope, scopeRoot, intentKey = null) {
  if (!scope) return true;
  if (asset.dataset.interactionScope !== scope) return false;
  if (intentKey && asset.dataset.interactionIntentKey !== intentKey) return false;
  if (!scopeRoot) return true;
  return asset.dataset.interactionRoot && document.getElementById(asset.dataset.interactionRoot) === scopeRoot;
}
function skipDisabledInteractionAsset(asset) {
  if (asset.dataset.interactionDesktopOnly !== "true" || !isMobileAnim) return false;
  asset.remove();
  return true;
}
function reportInteractionAssetError(error, detail = {}) {
  document.dispatchEvent(new CustomEvent("interaction-asset:error", {
    detail: {
      error,
      ...detail
    }
  }));
}
function createInteractionAssetError(message, name = "InteractionAssetError", detail = {}) {
  const error = new Error(message);
  error.name = name;
  Object.assign(error, detail);
  return error;
}
function waitForInteractionPromise(promise, timeout, message, detail = {}) {
  let timeoutId;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(() => {
      const error = createInteractionAssetError(message, "InteractionAssetTimeoutError", detail);
      reportInteractionAssetError(error, detail);
      reject(error);
    }, timeout);
  });
  return Promise.race([promise, timeoutPromise]).finally(() => clearTimeout(timeoutId));
}
function activateInteractionScript(source, scriptKey, scriptFragment) {
  const recordKey = scriptKey || source;
  const previous = _interactionModuleLoads.get(recordKey);
  if ((previous == null ? void 0 : previous.status) === "loading") {
    previous.sources.add(source);
    source.removeAttribute("data-interaction-error");
    source.setAttribute("data-interaction-activation", "loading");
    return previous.promise;
  }
  if ((previous == null ? void 0 : previous.status) === "ready") {
    source.remove();
    return previous.promise;
  }
  if ((previous == null ? void 0 : previous.attempts) >= INTERACTION_MODULE_MAX_ATTEMPTS) {
    source.removeAttribute("data-interaction-activation");
    source.setAttribute("data-interaction-error", previous.reason || "error");
    return previous.promise;
  }
  const attempt = ((previous == null ? void 0 : previous.attempts) || 0) + 1;
  const fresh = document.createElement("script");
  fresh.type = "module";
  fresh.crossOrigin = "anonymous";
  if (source.dataset.src) fresh.src = source.dataset.src;
  if (source.innerHTML) fresh.innerHTML = source.innerHTML;
  source.removeAttribute("data-interaction-error");
  source.setAttribute("data-interaction-activation", "loading");
  const record = {
    attempts: attempt,
    promise: null,
    reason: null,
    sources: (previous == null ? void 0 : previous.sources) || /* @__PURE__ */ new Set(),
    status: "loading"
  };
  record.sources.add(source);
  record.promise = new Promise((resolve, reject) => {
    let timeoutId;
    let settled = false;
    const settle = (loaded, reason = "error") => {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      fresh.removeEventListener("load", onLoad);
      fresh.removeEventListener("error", onError);
      if (loaded) {
        record.status = "ready";
        record.sources.forEach((marker) => marker.remove());
        record.sources.clear();
        if (scriptKey) _activatedInteractionAssets.add(scriptKey);
        resolve();
        return;
      }
      fresh.remove();
      record.reason = reason;
      record.status = "failed";
      record.sources.forEach((marker) => {
        marker.removeAttribute("data-interaction-activation");
        marker.setAttribute("data-interaction-error", reason);
      });
      if (scriptKey) _activatedInteractionAssets.delete(scriptKey);
      const retryable = attempt < INTERACTION_MODULE_MAX_ATTEMPTS;
      const error = createInteractionAssetError(
        `Interaction module failed to load: ${source.dataset.src || "inline module"}`,
        reason === "timeout" ? "InteractionAssetTimeoutError" : "InteractionAssetLoadError",
        {
          interactionRetryable: retryable,
          interactionTerminal: !retryable
        }
      );
      reportInteractionAssetError(error, {
        attempt,
        reason,
        type: "module",
        url: source.dataset.src || null
      });
      reject(error);
    };
    const onLoad = () => settle(true);
    const onError = () => settle(false, "error");
    fresh.addEventListener("load", onLoad, { once: true });
    fresh.addEventListener("error", onError, { once: true });
    timeoutId = setTimeout(() => settle(false, "timeout"), INTERACTION_MODULE_LOAD_TIMEOUT);
  });
  record.promise.catch(() => {
  });
  _interactionModuleLoads.set(recordKey, record);
  scriptFragment.appendChild(fresh);
  return record.promise;
}
function activateInteractionScripts(root, scope, scopeRoot, intentKey = null) {
  const scriptFragment = document.createDocumentFragment();
  const moduleLoads = [];
  Array.from(root.querySelectorAll('script[type="text/interaction-module"]')).filter((asset) => matchesInteractionScope(asset, scope, scopeRoot, intentKey)).forEach((s) => {
    if (skipDisabledInteractionAsset(s)) return;
    const scriptKey = getInteractionAssetKey("script", s.dataset.src);
    moduleLoads.push(activateInteractionScript(s, scriptKey, scriptFragment));
  });
  if (scriptFragment.childNodes.length) document.body.appendChild(scriptFragment);
  return moduleLoads;
}
function activateInteractionPreloads(root, scope, scopeRoot, intentKey = null) {
  Array.from(root.querySelectorAll('link[rel="interaction-modulepreload"]')).filter((asset) => matchesInteractionScope(asset, scope, scopeRoot, intentKey)).forEach((l) => {
    if (skipDisabledInteractionAsset(l)) return;
    const preloadKey = getInteractionAssetKey("modulepreload", l.dataset.href);
    if (preloadKey && _activatedInteractionAssets.has(preloadKey)) {
      l.remove();
      return;
    }
    if (preloadKey) _activatedInteractionAssets.add(preloadKey);
    l.rel = "modulepreload";
    if (l.dataset.href) l.href = l.dataset.href;
  });
}
function activateInteractionStylesheet(stylesheet) {
  if (skipDisabledInteractionAsset(stylesheet)) return;
  const stylesheetKey = getInteractionAssetKey("stylesheet", stylesheet.dataset.href);
  if (stylesheetKey && (_activatedInteractionAssets.has(stylesheetKey) || hasActiveStylesheet(stylesheetKey))) {
    stylesheet.remove();
    return;
  }
  if (stylesheetKey) _activatedInteractionAssets.add(stylesheetKey);
  stylesheet.rel = "stylesheet";
  if (stylesheet.dataset.href) stylesheet.href = stylesheet.dataset.href;
}
function activateInteractionStylesheets(root = document, scope = "global", scopeRoot = null, intentKey = null) {
  Array.from(root.querySelectorAll('link[rel="interaction-stylesheet"]')).filter((asset) => matchesInteractionScope(asset, scope, scopeRoot, intentKey)).forEach(activateInteractionStylesheet);
}
function activateInteractionAssets(root = document, scope = "global", scopeRoot = null, intentKey = null) {
  const moduleLoads = activateInteractionScripts(root, scope, scopeRoot, intentKey);
  activateInteractionPreloads(root, scope, scopeRoot, intentKey);
  activateInteractionStylesheets(root, scope, scopeRoot, intentKey);
  return moduleLoads;
}
function activateHeaderMenuInteractionAssets(root = document) {
  var _a;
  const headers = [];
  if (root instanceof Element && root.matches("header-v3-component")) {
    headers.push(root);
  }
  (_a = root.querySelectorAll) == null ? void 0 : _a.call(root, "header-v3-component").forEach((header) => {
    headers.push(header);
  });
  headers.forEach((header) => {
    header.querySelectorAll("menu-header-v2").forEach((menu) => {
      activateInteractionAssets(document, "viewport", menu);
    });
  });
}
const _pointerPrewarmedViewportRoots = /* @__PURE__ */ new WeakSet();
function prewarmViewportInteractionRoots(event) {
  var _a;
  if (event.isPrimary === false || event.pointerType !== "mouse") return;
  const roots = ((_a = event.composedPath) == null ? void 0 : _a.call(event).filter(
    (node) => node instanceof Element && node.hasAttribute("data-interaction-pointer-prewarm")
  )) ?? [];
  roots.forEach((scopeRoot) => {
    if (_pointerPrewarmedViewportRoots.has(scopeRoot)) return;
    _pointerPrewarmedViewportRoots.add(scopeRoot);
    activateInteractionAssets(document, "viewport", scopeRoot);
  });
}
const _intentActivationPromises = /* @__PURE__ */ new WeakMap();
function getInteractionIntentController(root, tagName) {
  if (!root || !tagName) return root;
  if (root.localName === tagName) return root;
  const viewportRootId = root.dataset.interactionViewportRoot;
  const viewportRoot = viewportRootId ? document.getElementById(viewportRootId) : null;
  if ((viewportRoot == null ? void 0 : viewportRoot.localName) === tagName) return viewportRoot;
  return root.closest(tagName) || root;
}
function isInteractionIntentReady(root, tagName) {
  if (!customElements.get(tagName)) return false;
  const controller = getInteractionIntentController(root, tagName);
  if (typeof (controller == null ? void 0 : controller.isInteractionReady) === "function") {
    return controller.isInteractionReady();
  }
  return true;
}
async function waitForInteractionElementDefinition(tagName, moduleLoads = []) {
  if (moduleLoads.length) await Promise.all(moduleLoads);
  if (customElements.get(tagName)) return;
  const timeout = moduleLoads.length ? INTERACTION_ELEMENT_DEFINITION_TIMEOUT : INTERACTION_UNTRACKED_DEFINITION_TIMEOUT;
  await waitForInteractionPromise(
    customElements.whenDefined(tagName),
    timeout,
    `Interaction element was not defined: ${tagName}`,
    {
      interactionTerminal: true,
      tagName,
      type: "definition"
    }
  );
}
async function prepareInteractionIntentController(root, tagName, moduleLoads = []) {
  if (!customElements.get(tagName)) {
    await waitForInteractionElementDefinition(tagName, moduleLoads);
  }
  const controller = getInteractionIntentController(root, tagName);
  if (!(controller == null ? void 0 : controller.isConnected)) return false;
  if (typeof controller.prepareInteraction === "function") {
    try {
      await waitForInteractionPromise(
        Promise.resolve(controller.prepareInteraction()),
        INTERACTION_CONTROLLER_READY_TIMEOUT,
        `Interaction controller did not become ready: ${tagName}`,
        {
          interactionTerminal: true,
          tagName,
          type: "controller"
        }
      );
    } catch (error) {
      const controllerError = error instanceof Error ? error : new Error(String(error));
      if (!controllerError.interactionTerminal) {
        controllerError.interactionTerminal = true;
        reportInteractionAssetError(controllerError, {
          reason: "error",
          tagName,
          type: "controller"
        });
      }
      throw controllerError;
    }
  }
  return root.isConnected && isInteractionIntentReady(root, tagName);
}
function getInteractionIntentRoot(event) {
  var _a;
  const target = ((_a = event.composedPath) == null ? void 0 : _a.call(event)[0]) ?? event.target;
  if (!(target instanceof Element)) return null;
  return target.closest("[data-interaction-intent], [data-interaction-prewarm]");
}
function prepareInteractionIntentRoot(root) {
  const tagName = root.dataset.interactionIntent || root.dataset.interactionPrewarm;
  if (!tagName || !tagName.includes("-")) return Promise.resolve(false);
  const moduleLoads = [];
  const viewportRootId = root.dataset.interactionViewportRoot;
  const viewportRoot = viewportRootId ? document.getElementById(viewportRootId) : null;
  if (viewportRoot) {
    moduleLoads.push(...activateInteractionAssets(document, "viewport", viewportRoot));
  }
  const intentKey = root.dataset.interactionIntentKey || tagName;
  moduleLoads.push(...activateInteractionAssets(document, "intent", null, intentKey));
  if (isInteractionIntentReady(root, tagName)) {
    root.removeAttribute("data-interaction-failed");
    return Promise.resolve(root.isConnected);
  }
  const pending = _intentActivationPromises.get(root);
  if (pending) return pending;
  const activation = prepareInteractionIntentController(root, tagName, moduleLoads).then((isReady) => {
    if (isReady) root.removeAttribute("data-interaction-failed");
    return isReady;
  }).catch((error) => {
    if (error == null ? void 0 : error.interactionTerminal) root.setAttribute("data-interaction-failed", "true");
    throw error;
  }).finally(() => {
    if (_intentActivationPromises.get(root) === activation) {
      _intentActivationPromises.delete(root);
    }
  });
  _intentActivationPromises.set(root, activation);
  return activation;
}
function interactionIntentHasFailed(root, tagName) {
  if (root.dataset.interactionFailed !== "true") return false;
  if (isInteractionIntentReady(root, tagName)) {
    root.removeAttribute("data-interaction-failed");
    return false;
  }
  return true;
}
function getInteractionReplayTarget(root, target, selectorAttribute) {
  const selector = root.dataset[selectorAttribute];
  if (!selector) return target;
  try {
    const match = target.closest(selector);
    return match && root.contains(match) ? match : null;
  } catch {
    return null;
  }
}
function prewarmPresenceDeferredTemplates() {
  const isMobile2 = window.matchMedia("(max-width: 991.98px)").matches;
  document.querySelectorAll([
    'deferred-template[data-inflate-on-presence="true"]',
    'deferred-template[data-inflate-on-presence-mobile="true"]'
  ].join(",")).forEach((template) => {
    if (template.dataset.inflateOnPresence !== "true" && !isMobile2) return;
    const root = template.closest("[data-interaction-prewarm]");
    if (root) prepareInteractionIntentRoot(root).catch(() => {
    });
  });
}
function prewarmInteractionIntent(event) {
  const root = getInteractionIntentRoot(event);
  if (!root) return;
  const tagName = root.dataset.interactionIntent || root.dataset.interactionPrewarm;
  if (!tagName || interactionIntentHasFailed(root, tagName)) return;
  if (root.hasAttribute("data-interaction-prewarm") && !root.hasAttribute("data-interaction-prewarm-all")) {
    if (!(event instanceof PointerEvent) || event.type !== "pointerover" || event.pointerType !== "mouse") return;
  }
  if (event instanceof PointerEvent && (event.isPrimary === false || event.type === "pointerover" && event.pointerType !== "mouse")) return;
  prepareInteractionIntentRoot(root).catch(() => {
  });
}
function getInteractionPendingTarget(root) {
  const selector = root.dataset.interactionPendingSelector;
  if (!selector) return null;
  try {
    return root.querySelector(selector);
  } catch {
    return null;
  }
}
function setInteractionPendingTarget(target, isPending) {
  if (!target) return;
  if (isPending) {
    if (target.getAttribute("loading") !== "true") target.setAttribute("loading", "true");
    if (target.getAttribute("aria-busy") !== "true") target.setAttribute("aria-busy", "true");
    return;
  }
  if (target.hasAttribute("loading")) target.removeAttribute("loading");
  if (target.hasAttribute("aria-busy")) target.removeAttribute("aria-busy");
}
function replayInteractionIntentClick(event) {
  var _a;
  const root = getInteractionIntentRoot(event);
  if (!root || !root.hasAttribute("data-interaction-intent")) return;
  const tagName = root.dataset.interactionIntent;
  if (!tagName || isInteractionIntentReady(root, tagName) || interactionIntentHasFailed(root, tagName)) return;
  const originalTarget = ((_a = event.composedPath) == null ? void 0 : _a.call(event)[0]) ?? event.target;
  if (!(originalTarget instanceof Element)) return;
  const replayTarget = getInteractionReplayTarget(
    root,
    originalTarget,
    "interactionReplayClickSelector"
  );
  if (!replayTarget) return;
  const pendingTarget = getInteractionPendingTarget(root);
  setInteractionPendingTarget(pendingTarget, true);
  _onFirstInteract(event);
  event.preventDefault();
  event.stopImmediatePropagation();
  prepareInteractionIntentRoot(root).then((isReady) => {
    if (!isReady || !replayTarget.isConnected) {
      setInteractionPendingTarget(pendingTarget, false);
      return;
    }
    replayTarget.dispatchEvent(new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      composed: true,
      view: window,
      detail: event.detail,
      clientX: event.clientX,
      clientY: event.clientY,
      button: event.button,
      buttons: event.buttons,
      ctrlKey: event.ctrlKey,
      shiftKey: event.shiftKey,
      altKey: event.altKey,
      metaKey: event.metaKey
    }));
  }).catch(() => {
    setInteractionPendingTarget(pendingTarget, false);
  });
}
function replayInteractionIntentKeydown(event) {
  var _a;
  if (event.defaultPrevented || event.isComposing) return;
  const root = getInteractionIntentRoot(event);
  if (!root || !root.hasAttribute("data-interaction-intent") || !root.hasAttribute("data-interaction-replay-keydown")) return;
  const tagName = root.dataset.interactionIntent;
  if (!tagName || isInteractionIntentReady(root, tagName) || interactionIntentHasFailed(root, tagName)) return;
  const isTypeahead = event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey;
  const isControlKey = [
    "Enter",
    " ",
    "ArrowDown",
    "ArrowUp",
    "ArrowLeft",
    "ArrowRight",
    "Home",
    "End"
  ].includes(event.key);
  if (!isTypeahead && !isControlKey) return;
  const originalTarget = ((_a = event.composedPath) == null ? void 0 : _a.call(event)[0]) ?? event.target;
  if (!(originalTarget instanceof Element)) return;
  const replayTarget = getInteractionReplayTarget(
    root,
    originalTarget,
    "interactionReplayKeydownSelector"
  );
  if (!replayTarget) return;
  _onFirstInteract(event);
  event.preventDefault();
  event.stopImmediatePropagation();
  prepareInteractionIntentRoot(root).then((isReady) => {
    if (!isReady || !replayTarget.isConnected) return;
    replayTarget.dispatchEvent(new KeyboardEvent("keydown", {
      bubbles: true,
      cancelable: true,
      composed: true,
      key: event.key,
      code: event.code,
      location: event.location,
      repeat: event.repeat,
      ctrlKey: event.ctrlKey,
      shiftKey: event.shiftKey,
      altKey: event.altKey,
      metaKey: event.metaKey
    }));
  }).catch(() => {
  });
}
function replayInteractionIntentInput(event) {
  var _a;
  const root = getInteractionIntentRoot(event);
  if (!root || !root.hasAttribute("data-interaction-intent") || !root.hasAttribute("data-interaction-replay-input")) return;
  const tagName = root.dataset.interactionIntent;
  if (!tagName || isInteractionIntentReady(root, tagName) || interactionIntentHasFailed(root, tagName)) return;
  const input = ((_a = event.composedPath) == null ? void 0 : _a.call(event)[0]) ?? event.target;
  if (!(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement)) return;
  _onFirstInteract(event);
  event.stopImmediatePropagation();
  prepareInteractionIntentRoot(root).then((isReady) => {
    if (!isReady || !input.isConnected) return;
    input.dispatchEvent(new InputEvent("input", {
      bubbles: true,
      composed: true,
      data: event.data,
      inputType: event.inputType,
      isComposing: event.isComposing
    }));
  }).catch(() => {
  });
}
function replayInteractionIntentChange(event) {
  var _a;
  const root = getInteractionIntentRoot(event);
  if (!root || !root.hasAttribute("data-interaction-replay-change")) return;
  const tagName = root.dataset.interactionIntent || root.dataset.interactionPrewarm;
  if (!tagName || isInteractionIntentReady(root, tagName) || interactionIntentHasFailed(root, tagName)) return;
  const originalTarget = ((_a = event.composedPath) == null ? void 0 : _a.call(event)[0]) ?? event.target;
  if (!(originalTarget instanceof Element)) return;
  const control = getInteractionReplayTarget(
    root,
    originalTarget,
    "interactionReplayChangeSelector"
  );
  if (!control) return;
  _onFirstInteract(event);
  event.stopImmediatePropagation();
  prepareInteractionIntentRoot(root).then((isReady) => {
    if (!isReady || !control.isConnected) return;
    control.dispatchEvent(new Event("change", {
      bubbles: true,
      composed: true
    }));
  }).catch(() => {
  });
}
function replayInteractionIntentSubmit(event) {
  const root = getInteractionIntentRoot(event);
  if (!root || !root.hasAttribute("data-interaction-replay-submit")) return;
  const tagName = root.dataset.interactionIntent || root.dataset.interactionPrewarm;
  if (!tagName || isInteractionIntentReady(root, tagName) || interactionIntentHasFailed(root, tagName)) return;
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const submitter = event.submitter;
  _onFirstInteract(event);
  event.preventDefault();
  event.stopImmediatePropagation();
  prepareInteractionIntentRoot(root).then((isReady) => {
    if (!isReady || !form.isConnected) return;
    if (submitter instanceof HTMLElement && submitter.isConnected && submitter.form === form) {
      form.requestSubmit(submitter);
    } else {
      form.requestSubmit();
    }
  }).catch(() => {
  });
}
document.addEventListener("pointerover", prewarmViewportInteractionRoots, { capture: true, passive: true });
document.addEventListener("pointerover", prewarmInteractionIntent, { capture: true, passive: true });
document.addEventListener("pointerdown", prewarmInteractionIntent, { capture: true, passive: true });
document.addEventListener("touchstart", prewarmInteractionIntent, { capture: true, passive: true });
document.addEventListener("focusin", prewarmInteractionIntent, { capture: true, passive: true });
document.addEventListener("click", replayInteractionIntentClick, { capture: true });
document.addEventListener("keydown", replayInteractionIntentKeydown, { capture: true });
document.addEventListener("input", replayInteractionIntentInput, { capture: true });
document.addEventListener("change", replayInteractionIntentChange, { capture: true });
document.addEventListener("submit", replayInteractionIntentSubmit, { capture: true });
function replayDeferredCartDrawerOpen(event) {
  var _a;
  const data = (_a = event.detail) == null ? void 0 : _a.data;
  if (customElements.get("cart-drawer") || (data == null ? void 0 : data.source) !== "product-form" || data.openDrawer === false) return;
  const drawer = document.getElementById("CartDrawer");
  if (!drawer || drawer.localName !== "cart-drawer") return;
  const moduleLoads = activateInteractionAssets(document, "intent", null, "CartDrawer");
  waitForInteractionElementDefinition("cart-drawer", moduleLoads).then(() => {
    if (!drawer.isConnected) return;
    event.target.dispatchEvent(new CustomEvent(event.type, {
      bubbles: true,
      detail: event.detail
    }));
  }).catch(() => {
  });
}
document.addEventListener("cart:update", replayDeferredCartDrawerOpen, { capture: true });
const VIEWPORT_STYLE_PASSIVE_MARGIN = "400px 0px";
const VIEWPORT_STYLE_INTENT_MARGIN = "1750px 0px";
const VIEWPORT_RUNTIME_MARGIN = "1750px 0px";
const VIEWPORT_PRESENCE_RUNTIME_MARGIN = "1750px 0px";
const VIEWPORT_INITIAL_RUNTIME_MARGIN = "0px";
const VIEWPORT_EARLY_RUNTIME_MARGIN = "1750px 0px";
const _viewportPassiveStyleRoots = /* @__PURE__ */ new WeakSet();
const _viewportIntentStyleRoots = /* @__PURE__ */ new WeakSet();
const _viewportRuntimeRoots = /* @__PURE__ */ new WeakSet();
const _viewportPresenceRuntimeRoots = /* @__PURE__ */ new WeakSet();
const _viewportInitialRuntimeRoots = /* @__PURE__ */ new WeakSet();
const _viewportEarlyRuntimeRoots = /* @__PURE__ */ new WeakSet();
function observeInteractionRoots(roots, observedRoots, rootMargin, activate) {
  const targets = Array.from(roots).filter((scopeRoot) => !observedRoots.has(scopeRoot));
  if (!targets.length) return;
  targets.forEach((scopeRoot) => observedRoots.add(scopeRoot));
  if (!("IntersectionObserver" in window)) {
    targets.forEach(activate);
    return;
  }
  let pendingTargets = targets.length;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      pendingTargets -= 1;
      activate(entry.target, entry);
      if (pendingTargets === 0) observer.disconnect();
    });
  }, { rootMargin });
  targets.forEach((scopeRoot) => observer.observe(scopeRoot));
}
function setupViewportInteractionAssets(root = document) {
  const assets = Array.from(root.querySelectorAll('[data-interaction-scope="viewport"]'));
  const styleRoots = /* @__PURE__ */ new Set();
  const runtimeRoots = /* @__PURE__ */ new Set();
  const presenceRuntimeRoots = /* @__PURE__ */ new Set();
  const initialRuntimeRoots = /* @__PURE__ */ new Set();
  const earlyRuntimeRoots = /* @__PURE__ */ new Set();
  for (const asset of assets) {
    const rootId = asset.dataset.interactionRoot;
    const scopeRoot = rootId && document.getElementById(rootId);
    if (!scopeRoot) {
      if (asset.matches('link[rel="interaction-stylesheet"]')) {
        activateInteractionStylesheet(asset);
      } else {
        asset.dataset.interactionScope = "global";
      }
      continue;
    }
    if (asset.matches('link[rel="interaction-stylesheet"]')) {
      styleRoots.add(scopeRoot);
    } else if (asset.dataset.interactionEarlyViewport === "true") {
      earlyRuntimeRoots.add(scopeRoot);
    } else if (asset.dataset.interactionInitialViewport === "true") {
      initialRuntimeRoots.add(scopeRoot);
    } else if (asset.dataset.interactionPresencePriority === "true") {
      presenceRuntimeRoots.add(scopeRoot);
    } else {
      runtimeRoots.add(scopeRoot);
    }
  }
  presenceRuntimeRoots.forEach((scopeRoot) => runtimeRoots.delete(scopeRoot));
  initialRuntimeRoots.forEach((scopeRoot) => {
    runtimeRoots.delete(scopeRoot);
    presenceRuntimeRoots.delete(scopeRoot);
  });
  earlyRuntimeRoots.forEach((scopeRoot) => {
    runtimeRoots.delete(scopeRoot);
    presenceRuntimeRoots.delete(scopeRoot);
    initialRuntimeRoots.delete(scopeRoot);
  });
  observeInteractionRoots(
    earlyRuntimeRoots,
    _viewportEarlyRuntimeRoots,
    VIEWPORT_EARLY_RUNTIME_MARGIN,
    (scopeRoot) => activateInteractionAssets(document, "viewport", scopeRoot)
  );
  observeInteractionRoots(
    initialRuntimeRoots,
    _viewportInitialRuntimeRoots,
    VIEWPORT_INITIAL_RUNTIME_MARGIN,
    (scopeRoot) => requestIdleCallback(
      () => activateInteractionAssets(document, "viewport", scopeRoot),
      { timeout: 500 }
    )
  );
  observeInteractionRoots(
    styleRoots,
    _viewportPassiveStyleRoots,
    VIEWPORT_STYLE_PASSIVE_MARGIN,
    (scopeRoot) => activateInteractionStylesheets(document, "viewport", scopeRoot)
  );
  onFirstUserPresence(() => {
    observeInteractionRoots(
      styleRoots,
      _viewportIntentStyleRoots,
      VIEWPORT_STYLE_INTENT_MARGIN,
      (scopeRoot) => activateInteractionStylesheets(document, "viewport", scopeRoot)
    );
  });
  onFirstUserPresence(() => {
    observeInteractionRoots(
      presenceRuntimeRoots,
      _viewportPresenceRuntimeRoots,
      VIEWPORT_PRESENCE_RUNTIME_MARGIN,
      (scopeRoot) => activateInteractionAssets(document, "viewport", scopeRoot)
    );
  });
  onFirstUserPresence(() => requestIdleCallback(() => {
    observeInteractionRoots(
      runtimeRoots,
      _viewportRuntimeRoots,
      VIEWPORT_RUNTIME_MARGIN,
      (scopeRoot) => activateInteractionAssets(document, "viewport", scopeRoot)
    );
  }));
}
onFirstUserPresence(prewarmPresenceDeferredTemplates);
onFirstUserPresence(() => activateInteractionAssets(document, "presence"));
onFirstPointerPresence(() => activateInteractionAssets(document, "pointer-presence"));
onFirstInteraction(() => activateHeaderMenuInteractionAssets());
onFirstInteraction(() => activateInteractionAssets(document, "global"));
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => setupViewportInteractionAssets(), { once: true });
} else {
  setupViewportInteractionAssets();
}
function preloadImage(src) {
  const image = new Image();
  image.src = src;
}
let _cachedFontSize = null;
window.addEventListener("resize", () => {
  _cachedFontSize = null;
}, { passive: true });
function getBaseFontSize() {
  return _cachedFontSize ?? (_cachedFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize));
}
function remToPx(rem) {
  return rem * getBaseFontSize();
}
function pxToRem(px) {
  return px / getBaseFontSize() + "rem";
}
class ResizeNotifier extends ResizeObserver {
  constructor(callback) {
    super((entries) => {
      if (__privateGet(this, _initialized)) return callback(entries, this);
      __privateSet(this, _initialized, true);
    });
    __privateAdd(this, _initialized, false);
  }
  disconnect() {
    __privateSet(this, _initialized, false);
    super.disconnect();
  }
}
_initialized = new WeakMap();
function formatMoney(cents, format = "{{amount_no_decimals_with_comma_separator}}") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const defaultFormat = format || "{{amount}}";
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) return "0";
    number = (number / 100).toFixed(precision);
    const parts = number.split(".");
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    const cents2 = parts[1] ? decimal + parts[1] : "";
    return dollars + cents2;
  }
  switch (defaultFormat.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }
  return defaultFormat.replace(placeholderRegex, value);
}
function fetchConfig(type = "json", config = {}) {
  const headers = { "Content-Type": "application/json", Accept: `application/${type}`, ...config.headers };
  if (type === "javascript") {
    headers["X-Requested-With"] = "XMLHttpRequest";
    delete headers["Content-Type"];
  }
  return {
    method: "POST",
    headers: (
      /** @type {HeadersInit} */
      headers
    ),
    body: config.body
  };
}
function debounce(fn, wait) {
  let timeout;
  function debounced(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  }
  debounced.cancel = () => {
    clearTimeout(timeout);
  };
  return (
    /** @type {T & { cancel(): void }} */
    debounced
  );
}
function onAnimationEnd(elements, callback, options = { subtree: true }) {
  const animations = Array.isArray(elements) ? elements.flatMap((element) => element.getAnimations(options)) : elements.getAnimations(options);
  const animationPromises = animations.reduce(
    (acc, animation) => {
      if (animation.timeline instanceof DocumentTimeline) {
        acc.push(animation.finished);
      }
      return acc;
    },
    /** @type {Promise<Animation>[]} */
    []
  );
  return Promise.allSettled(animationPromises).then(callback);
}
function isClickedOutside(event, element) {
  if (event.target instanceof HTMLDialogElement || !(event.target instanceof Element) || event.target.getRootNode() !== document) {
    return !isPointWithinElement(event.clientX, event.clientY, element);
  }
  return !element.contains(event.target);
}
function isPointWithinElement(x, y, element) {
  const { left, right, top, bottom } = element.getBoundingClientRect();
  return x >= left && x <= right && y >= top && y <= bottom;
}
const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)");
reducedMotion.addEventListener("change", (event) => {
  if (!event.matches) return;
  queueMicrotask(() => {
    document.querySelectorAll("anim-text, anim-element, anim-divider, anim-media, quantity-selector-component").forEach((component) => {
      var _a, _b;
      if (component.localName === "anim-text") {
        (_a = component.reset) == null ? void 0 : _a.call(component, true, true);
      } else {
        (_b = component.reset) == null ? void 0 : _b.call(component, { force: true });
      }
    });
  });
});
function prefersReducedMotion() {
  var _a, _b;
  return reducedMotion.matches || ((_b = (_a = document == null ? void 0 : document.body) == null ? void 0 : _a.dataset) == null ? void 0 : _b.reduceMotion) === "true";
}
let _themeSettings = null;
const isTouch = window.matchMedia("(pointer: coarse)").matches;
function getThemeSettings() {
  var _a, _b;
  if (!_themeSettings) {
    _themeSettings = {
      get reduceMotion() {
        return prefersReducedMotion();
      },
      get useCustomCursor() {
        return document.querySelector("cursor-component") !== null && !isTouchDevice();
      },
      get useSmoothScroll() {
        var _a2, _b2;
        return ((_b2 = (_a2 = document.body) == null ? void 0 : _a2.dataset) == null ? void 0 : _b2.ursusSmoothscroll) === "true" && !prefersReducedMotion() && !isTouch;
      },
      layoutMode: ((_b = (_a = document.body) == null ? void 0 : _a.dataset) == null ? void 0 : _b.layoutMode) || "default"
    };
  }
  return _themeSettings;
}
function resetShimmer(container = document.body) {
  if (!(container instanceof HTMLElement) || Shopify.designMode) {
    return;
  } else {
    const shimmer = container.querySelectorAll("[shimmer]");
    shimmer.forEach((item) => item.removeAttribute("shimmer"));
  }
}
class TextAnim extends HTMLElement {
  shimmer() {
    if (Shopify.designMode) return;
    this.setAttribute("shimmer", "");
  }
}
if (!customElements.get("text-anim")) {
  customElements.define("text-anim", TextAnim);
}
function onDocumentReady(callback) {
  if (document.readyState === "complete") {
    callback();
  } else {
    window.addEventListener("load", callback);
  }
}
function getScreenSize() {
  const media = window.matchMedia("(max-width: 768px)");
  return {
    isMobile: media.matches,
    isDesktop: !media.matches
  };
}
function isInViewPort(element) {
  const { top, bottom, left, right } = element.getBoundingClientRect();
  return top >= 0 && bottom <= window.innerHeight && left >= 0 && right <= window.innerWidth;
}
function scrollTargetTopIntoView(target, offsetVh = 10) {
  if (!(target instanceof Element)) return false;
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const targetTop = target.getBoundingClientRect().top;
  if (targetTop >= 0 && targetTop <= viewportHeight) return false;
  const offset = viewportHeight * (offsetVh / 100);
  const top = Math.max(0, window.scrollY + targetTop - offset);
  window.scrollTo({
    top,
    behavior: prefersReducedMotion() ? "auto" : "smooth"
  });
  return true;
}
function onDocumentLoaded(callback) {
  if (document.readyState === "complete") {
    callback();
  } else {
    window.addEventListener("load", callback);
  }
}
function isMobile() {
  return window.matchMedia && window.matchMedia("(max-width: 991.98px)").matches;
}
function isTablet() {
  return window.matchMedia && window.matchMedia("(max-width: 991.98px)").matches && window.matchMedia("(min-width: 768px)").matches;
}
function isDesktop() {
  return window.matchMedia && window.matchMedia("(min-width: 992px)").matches;
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
function resizeHandler(cb) {
  const resizeObserver = new ResizeObserver(() => {
    const scrollHeight = document.body.scrollHeight;
    let timer = null;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      if (document.body.scrollHeight !== scrollHeight) {
        cb();
      }
    }, 150);
  });
  resizeObserver.observe(document.body);
  return () => resizeObserver.disconnect();
}
const _tpl = document.createElement("template");
function setInnerHTML(element, html) {
  _tpl.innerHTML = html;
  const frag = _tpl.content;
  for (const old of frag.querySelectorAll("script")) {
    const fresh = document.createElement("script");
    for (const attr of old.attributes) fresh.setAttribute(attr.name, attr.value);
    fresh.textContent = old.textContent;
    old.replaceWith(fresh);
  }
  if (hasInteracted()) {
    frag.querySelectorAll('link[rel="interaction-stylesheet"][data-interaction-scope="global"]').forEach((l) => {
      l.rel = "stylesheet";
      if (l.dataset.href) l.href = l.dataset.href;
    });
    frag.querySelectorAll('link[rel="interaction-modulepreload"][data-interaction-scope="global"]').forEach((l) => {
      l.rel = "modulepreload";
      if (l.dataset.href) l.href = l.dataset.href;
    });
  }
  preserveLoadedStylesheets(element, frag);
  element.replaceChildren(frag);
  hydrateDynamicContent(element);
}
function hydrateDynamicContent(root) {
  if (!(root == null ? void 0 : root.querySelectorAll)) return;
  lazyReveal(root);
  if (hasUserPresence()) {
    activateInteractionAssets(root, "presence");
  }
  if (hasInteracted()) {
    activateInteractionAssets(root);
  }
  setupViewportInteractionAssets(root);
  requestDesignModeAssetHydration(root);
}
function requestDesignModeAssetHydration(root) {
  if (!isDesignMode || !(root == null ? void 0 : root.querySelectorAll)) return;
  document.dispatchEvent(new CustomEvent(DESIGN_MODE_ASSET_HYDRATION_EVENT, {
    detail: { root }
  }));
}
function setCookie(name, value, days = 30, path = "/") {
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${path}; max-age=${maxAge}`;
}
function getCookie(name) {
  const cookieArr = document.cookie.split("; ");
  for (let cookie of cookieArr) {
    const [key, val] = cookie.split("=");
    if (decodeURIComponent(key) === name) {
      return decodeURIComponent(val);
    }
  }
  return null;
}
const _jumboCTX = window.__jumboCTX ?? (window.__jumboCTX = document.createElement("canvas").getContext("2d"));
const _hasLetterSpacing = "letterSpacing" in _jumboCTX;
function findOptimalFontSize(text, containerWidth, computedStyle) {
  const { fontStyle, fontWeight, fontFamily, letterSpacing } = computedStyle;
  const baseFontSize = parseFloat(computedStyle.fontSize);
  const lsPx = parseFloat(letterSpacing) || 0;
  const lsRatio = baseFontSize ? lsPx / baseFontSize : 0;
  let minSize = 1, maxSize = 2e3;
  while (maxSize - minSize > 0.5) {
    const midSize = (minSize + maxSize) / 2;
    _jumboCTX.font = `${fontStyle} ${fontWeight} ${midSize}px ${fontFamily}`;
    if (_hasLetterSpacing) _jumboCTX.letterSpacing = `${lsRatio * midSize}px`;
    if (_jumboCTX.measureText(text).width > containerWidth) {
      maxSize = midSize;
    } else {
      minSize = midSize;
    }
  }
  return minSize * 0.99;
}
let _pendingBroadEntries = /* @__PURE__ */ new Set();
onFirstInteraction(() => {
  const elements = Array.from(_pendingBroadEntries);
  for (const el of elements) {
    const fn = _lazyCbs.get(el);
    if (fn) {
      _unobserveAll(el);
      setTimeout(() => {
        if (el.isConnected) fn();
      }, 0);
    }
  }
  _pendingBroadEntries.clear();
}, 0);
let _lazyIO_strict = null;
let _lazyIO_broad = null;
const _lazyCbs = /* @__PURE__ */ new WeakMap();
function _unobserveAll(el) {
  _lazyIO_strict == null ? void 0 : _lazyIO_strict.unobserve(el);
  _lazyIO_broad == null ? void 0 : _lazyIO_broad.unobserve(el);
  _pendingBroadEntries.delete(el);
  _lazyCbs.delete(el);
}
function lazyInit(el, cb, margin = "200% 0px") {
  if (!_lazyIO_strict) {
    _lazyIO_strict = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const fn = _lazyCbs.get(entry.target);
          if (fn) {
            _unobserveAll(entry.target);
            setTimeout(() => {
              if (entry.target.isConnected) fn();
            }, 0);
          }
        }
      }
    }, { rootMargin: "10px 0px" });
    _lazyIO_broad = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          if (hasInteracted()) {
            const fn = _lazyCbs.get(entry.target);
            if (fn) {
              _unobserveAll(entry.target);
              setTimeout(() => {
                if (entry.target.isConnected) fn();
              }, 0);
            }
          } else {
            _pendingBroadEntries.add(entry.target);
          }
        } else {
          _pendingBroadEntries.delete(entry.target);
        }
      }
    }, { rootMargin: margin });
  }
  _lazyCbs.set(el, cb);
  _lazyIO_strict.observe(el);
  _lazyIO_broad.observe(el);
}
function onLazyLoad(e) {
  e.target.setAttribute("loaded", "");
  if (e.target.parentElement) e.target.parentElement.removeAttribute("data-lazy-loading");
}
function onLazyError(e) {
  e.target.setAttribute("loaded", "");
  if (e.target.parentElement) e.target.parentElement.removeAttribute("data-lazy-loading");
}
function lazyReveal(scope = document) {
  const imgs = scope.querySelectorAll('img[loading="lazy"]:not([loaded])');
  if (!imgs.length) return;
  const toMark = [];
  const toWatch = [];
  for (const img of imgs) {
    if (img.complete && img.naturalWidth > 0) toMark.push(img);
    else toWatch.push(img);
  }
  for (const img of toMark) {
    img.setAttribute("loaded", "");
    if (img.parentElement) img.parentElement.removeAttribute("data-lazy-loading");
  }
  for (const img of toWatch) {
    if (img.parentElement) img.parentElement.setAttribute("data-lazy-loading", "");
    img.addEventListener("load", onLazyLoad, { once: true });
    img.addEventListener("error", onLazyError, { once: true });
  }
  if (toWatch.length) {
    const safetyCheck = (delay) => setTimeout(() => {
      for (const img of toWatch) {
        if (img.complete && img.naturalWidth > 0 && !img.hasAttribute("loaded")) {
          img.removeEventListener("load", onLazyLoad);
          img.removeEventListener("error", onLazyError);
          img.setAttribute("loaded", "");
          if (img.parentElement) img.parentElement.removeAttribute("data-lazy-loading");
        }
      }
    }, delay);
    safetyCheck(200);
    safetyCheck(2e3);
  }
}
requestIdleCallback(() => lazyReveal());
let _pendingRevealRaf = false;
const _lazyImgObserver = new MutationObserver((mutations) => {
  if (_pendingRevealRaf) return;
  for (const mutation of mutations) {
    if (mutation.addedNodes.length === 0) continue;
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.tagName === "IMG" && node.getAttribute("loading") === "lazy" || node.querySelectorAll && node.querySelector('img[loading="lazy"]:not([loaded])')) {
        _pendingRevealRaf = true;
        requestAnimationFrame(() => {
          _pendingRevealRaf = false;
          lazyReveal();
        });
        return;
      }
    }
  }
});
if (document.readyState === "complete") {
  _lazyImgObserver.observe(document.body, { childList: true, subtree: true });
} else {
  window.addEventListener("load", () => {
    _lazyImgObserver.observe(document.body, { childList: true, subtree: true });
  }, { once: true });
}
const domBatcher = {
  reads: [],
  writes: [],
  scheduled: false,
  read(fn) {
    this.reads.push(fn);
    this.schedule();
  },
  write(fn) {
    this.writes.push(fn);
    this.schedule();
  },
  schedule() {
    if (!this.scheduled) {
      this.scheduled = true;
      requestAnimationFrame(() => this.flush());
    }
  },
  flush() {
    let read, write;
    const start = performance.now();
    const BUDGET = 12;
    let readCount = this.reads.length;
    while (readCount-- && (read = this.reads.shift())) {
      try {
        read();
      } catch (e) {
      }
      if (performance.now() - start > BUDGET) break;
    }
    if (performance.now() - start <= BUDGET) {
      let writeCount = this.writes.length;
      while (writeCount-- && (write = this.writes.shift())) {
        try {
          write();
        } catch (e) {
        }
        if (performance.now() - start > BUDGET) break;
      }
    }
    this.scheduled = false;
    if (this.reads.length > 0 || this.writes.length > 0) this.schedule();
  }
};
const checkIsAboveFold = (entry) => {
  if (!entry) return false;
  if (entry.isIntersecting) return true;
  const rect = entry.boundingClientRect;
  if (!rect || rect.width === 0 && rect.height === 0) return false;
  return rect.top < window.innerHeight;
};
const setMediaControls = (rootElement, enabled) => {
  var _a, _b;
  if (!rootElement) return;
  const videoEl = rootElement instanceof HTMLVideoElement ? rootElement : (_a = rootElement.querySelector) == null ? void 0 : _a.call(rootElement, "video");
  const iframeEl = rootElement instanceof HTMLIFrameElement ? rootElement : (_b = rootElement.querySelector) == null ? void 0 : _b.call(rootElement, "iframe[data-video-type]");
  if (videoEl) {
    if (enabled) {
      videoEl.controls = true;
    } else {
      videoEl.removeAttribute("controls");
    }
  } else if (iframeEl == null ? void 0 : iframeEl.src) {
    try {
      const url = new URL(iframeEl.src);
      url.searchParams.set("controls", enabled ? "1" : "0");
      iframeEl.src = url.toString();
    } catch (e) {
    }
  }
};
export {
  ResizeNotifier,
  TextAnim,
  activateHeaderMenuInteractionAssets,
  activateInteractionAssets,
  activateInteractionStylesheets,
  checkIsAboveFold,
  debounce,
  domBatcher,
  fetchConfig,
  findOptimalFontSize,
  formatMoney,
  getBaseFontSize,
  getCookie,
  getScreenSize,
  getThemeSettings,
  hasInteracted,
  hasUserPresence,
  hydrateDynamicContent,
  installLinkedResponseStylesheets,
  installSectionStylesheets,
  isClickedOutside,
  isDesktop,
  isInViewPort,
  isMobile,
  isPointWithinElement,
  isTablet,
  isTouchDevice,
  lazyInit,
  lazyReveal,
  onAnimationEnd,
  onDocumentLoaded,
  onDocumentReady,
  onFirstInteraction,
  onFirstInteractionIdle,
  onFirstPointerPresence,
  onFirstUserPresence,
  onFirstUserPresenceIdle,
  prefersReducedMotion,
  preloadImage,
  preserveLoadedStylesheets,
  pxToRem,
  remToPx,
  requestDesignModeAssetHydration,
  requestIdleCallback,
  resetShimmer,
  resizeHandler,
  scrollTargetTopIntoView,
  setCookie,
  setInnerHTML,
  setMediaControls,
  setupViewportInteractionAssets
};
